import React, { useEffect, useState } from "react";
import MenuBar from "../../components/atoms/menuBar/MenuBar";
import { ABOUT_US_PATH } from "../../router/Routes";
import "./aboutMe.css";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { getImages } from "../../services";

const AboutMe = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    getImages().then((result) => {
      const aux = [];
      result.forEach((image) => {
        aux.push({ original: image.url, thumbnail: image.url });
      });
      setImages([...aux]);
    });
  }, []);

  return (
    <div className="main-container about-me-background">
      <MenuBar view={ABOUT_US_PATH} />
      <div className="view-content">
        <div className="animated-text-container about-us-content">
          <div className="about-us-child-container">
            <span>
              <div className="about-us-text">
                En Aglomerados de Colombia SAS estamos comprometidos en
                brindarle el mejor servicio siempre. Contamos con almacenes en
                las ciudades de Cali, Palmira, Popayán, Tulua, Armenia y Pereira
                dotados con la infraestructura tecnológica, intelectual y
                logística necesaria para brindarle apoyo a la industria del
                mueble y la carpintería arquitectónica.
              </div>
            </span>
            <div className="video-container">
              <iframe
                src="https://www.youtube.com/embed/FKYpA8WrW9U?rel=0"
                height="100%"
                width="100%"
                title="aglocol"
                style={{ border: "none;" }}
              />
            </div>
          </div>

          <div className="info-container">
            <ImageGallery
              items={images}
              showPlayButton={false}
              autoPlay={true}
              showBullets={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
